//File imports
import HttpService from '../../../services/Http/HttpService';
import Logger from '../../../services/Logger/Logger';
import Validator from '../../../services/Validator/Validator';
import {
    API_CREATE_ARTICLE_TRANSLATION,
    API_IS_URL_EXISTS_ARTICLE,
    API_UPDATE_ARTICLE_TRANSLATION,
    GET_SINGLE_ARTICLE_TRANSLATION,
} from './ArticleTranslationConstants';
import DocumentTemplateTranslationResultsPojo from './ArticleTranslationResultsPojo';

export class ArticleTranslationService {
    private httpService = new HttpService();
    private logger = new Logger();
    private validator = new Validator();

    async create(data: any): Promise<{ success: boolean; message: string }> {
        const {
            articleTitle,
            url,
            metaTitle,
            metaKeyword,
            metaDescription,
            youtubeLink,
            shortDescription,
            description,
            articleId,
            languageId,
            thumbnail,
            folderName,
        } = data;
        try {
            this.validator.isValidString('title', articleTitle);
            this.validator.isValidString('url', url);
            this.validator.isValidString('metaTitle', metaTitle);
            this.validator.isValidString('metaKeyword', metaKeyword);
            this.validator.isValidString('metaDescription', metaDescription);
            this.validator.isValidString('shortDescription', shortDescription);
            this.validator.isValidString('description', description);
            if (youtubeLink) {
                this.validator.isValidString('youtubeVideoLink', youtubeLink);
            }

            let formData = new FormData();
            formData.append('articleId', articleId);
            formData.append('languageId', languageId);
            formData.append('title', articleTitle);
            formData.append('url', url.toLowerCase());
            formData.append('metaTitle', metaTitle);
            formData.append('metaKeyword', metaKeyword);
            formData.append('metaDescription', metaDescription);
            formData.append('shortDescription', shortDescription);
            formData.append('description', description);
            formData.append('thumbnail', thumbnail);
            formData.append('folderName', folderName);
            if (youtubeLink) {
                formData.append('youtubeVideoLink', youtubeLink);
            }

            const httpResult = await this.httpService.postFormData(
                API_CREATE_ARTICLE_TRANSLATION,
                formData,
            );
            return {
                success: httpResult.data.isSuccess,
                message: httpResult.data.messageForUser,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async update(data: any): Promise<{ success: boolean; message: string }> {
        const {
            articleTitle,
            url,
            metaTitle,
            metaKeyword,
            metaDescription,
            youtubeLink,
            shortDescription,
            description,
            articleId,
            languageId,
            articleTranslationId,
            thumbnail,
        } = data;
        try {
            this.validator.validatePositiveInteger(articleId);
            this.validator.validatePositiveInteger(languageId);
            this.validator.validatePositiveInteger(articleTranslationId);
            this.validator.isValidString('title', articleTitle);
            this.validator.isValidString('url', url);
            this.validator.isValidString('metaTitle', metaTitle);
            this.validator.isValidString('metaKeyword', metaKeyword);
            this.validator.isValidString('metaDescription', metaDescription);
            this.validator.isValidString('shortDescription', shortDescription);
            this.validator.isValidString('description', description);
            if (youtubeLink) {
                this.validator.isValidString('youtubeVideoLink', youtubeLink);
            }

            let formData = new FormData();
            formData.append('articleId', articleId);
            formData.append('articleTranslationId', articleTranslationId);
            formData.append('languageId', languageId);
            formData.append('title', articleTitle);
            formData.append('url', url.toLowerCase());
            formData.append('metaTitle', metaTitle);
            formData.append('metaKeyword', metaKeyword);
            formData.append('metaDescription', metaDescription);
            formData.append('shortDescription', shortDescription);
            formData.append('description', description);
            formData.append('thumbnail', thumbnail);
            formData.append('youtubeVideoLink', youtubeLink);

            const httpResult = await this.httpService.postFormData(
                API_UPDATE_ARTICLE_TRANSLATION,
                formData,
            );
            return {
                success: httpResult.data.isSuccess,
                message: httpResult.data.messageForUser,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async get(data: any): Promise<DocumentTemplateTranslationResultsPojo> {
        const { articleId, languageId } = data;
        try {
            this.validator.validatePositiveInteger(articleId);
            this.validator.validatePositiveInteger(languageId);

            const httpResult = await this.httpService.get(
                GET_SINGLE_ARTICLE_TRANSLATION(articleId, languageId),
                {},
            );
            return {
                success: httpResult.data.isSuccess,
                message: httpResult.data.messageForUser,
                data: httpResult.data.response,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async isUrlExists(
        url: string,
        isFooterLink: number,
    ): Promise<{ success: boolean; message: string }> {
        try {
            this.validator.isValidString('url', url);
            this.validator.validateIntegerIncludingZero(isFooterLink);
            const payload: any = {
                url: url.toLowerCase(),
                isFooterLink,
            };

            const httpResult = await this.httpService.post(
                API_IS_URL_EXISTS_ARTICLE,
                payload,
            );
            return {
                success: httpResult.data.isSuccess,
                message: httpResult.data.messageForUser,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }
}
